<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'COMMUNITY-PROVIDER-PROGRAM'" [breadcrumb]="''"
    [count]="total" icon="fa-cog">
</app-breadcrumb>
<div class="content-background" style="display: grid;">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="communityProviderGridAdvancedSwitch" [storageKey]="'groups-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView"
            [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-COMMUNITY-PROVIDER' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="id" title="{{'ID' | translate}}" [width]="20" [hidden]="true" filter="numeric"
                format="{0:n}">
            </kendo-grid-column>
            <kendo-grid-column field="name" title="{{'PROGRAM-NAME' | translate}}" [width]="20">
            </kendo-grid-column>
            <kendo-grid-column class="ellipsis-text" field="description" title="{{'DESCRIPTION' | translate}}"
                [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span title="{{dataItem.description}}">{{dataItem.description}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="categoryName" title="{{'COMMUNITY-SERVICE-CATEGORY' | translate}}" [width]="10">
            </kendo-grid-column>
            <kendo-grid-column field="serviceTypeName" title="{{'COMMUNITY-SERVICE-TYPE' | translate}}" [width]="8">
            </kendo-grid-column>
            <kendo-grid-column class="ellipsis-text" field="eligibility" title="{{'ELIGIBILITY' | translate}}"
                [width]="10" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.eligibility">{{dataItem.eligibility}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cost" title="{{'COST' | translate}}" [width]="15" [hidden]="true">
            </kendo-grid-column>
            <kendo-grid-column field="organization" title="{{'ORGANIZATION' | translate}}" [width]="10">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.organization">{{dataItem.organization.name}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="ellipsis-text" field="submittingOrganization"
                title="{{'SUBMITTING-ORGANIZATION' | translate}}" [width]="10" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.submittingOrganization">{{dataItem.submittingOrganization.name}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="channelName" title="{{'REFERRAL-CHANNEL' | translate}}" [width]="10">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.channel">{{dataItem.channel.name}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="resourceStatusName" title="{{'STATUS' | translate}}" [width]="10">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.resourceStatusName">{{dataItem.resourceStatusName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="address" title="{{'ADDRESS' | translate}}" [width]="15" [sortable]="false"
                [filterable]="false" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.address">
                        <span
                            *ngIf="dataItem.address.streetLine || dataItem.address.streetLineAdditional">{{dataItem.address.streetLine}}
                            {{dataItem.address.streetLineAdditional}}<br />
                        </span>
                        <span *ngIf="dataItem.address.city">
                            {{dataItem.address.city}}
                        </span>
                        <span *ngIf="dataItem.address.state">
                            {{dataItem.address.state.code}}
                        </span>
                        <span *ngIf="dataItem.address.postalCode">
                            {{dataItem.address.postalCode}}
                        </span>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column [width]="8" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i *ngIf="!isDirectoryManager" class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button"
            class="float-right mt-3 ml-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
        <button kendoButton [primary]="false" type="button"
            title="{{'IMPORT-COMMUNITY-PROGRAMS-FROM-CSV' | translate}}" (click)="openCommunityProviderProgramsImport()"
            class="float-right mt-3 ml-3">{{'IMPORT' | translate}}<i class="far fa-file-import"></i>
        </button>
        <button kendoButton [primary]="false" type="button" title="{{'EXPORT-COMMUNITY-PROGRAMS-TO-CSV' | translate}}"
            class="float-right mt-3 ml-3" (click)="exportCommunityProvidersToCsv()">{{'EXPORT' | translate}}<i
                class="far fa-file-export"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-community-provider-program-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler()"
    (cancelling)="cancelChangesHandler()">
</app-community-provider-program-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedProgram.name}}</span>
    <div class="deletion-warning mt-4" *ngIf="programInUse">{{'COMMUNITY-PROVIDER-PROGRAM-IN-USE-WARNING' | translate }}
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-community-provider-program-import #importCommunityProviderPrograms (loadedCommunityPrograms)="refreshGrid()">
</app-community-provider-program-import>